import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronLeft';
/** Renders an SVG icon. */
const SvgChevronLeft = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19.796 23.796a1.126 1.126 0 0 0 0-1.591L13.59 16l6.205-6.205a1.125 1.125 0 0 0-1.591-1.59l-7 7a1.123 1.123 0 0 0 0 1.59l7 7c.439.44 1.151.44 1.59 0Z"
      />
    </svg>
  );
};
SvgChevronLeft.displayName = displayName;
export default SvgChevronLeft;
